import { type ReactNode, useEffect, useState } from "react";

import { flagg } from "../core";
import { FlaggContext } from "./context";

export function FlaggProvider<FF extends ReturnType<typeof flagg>>({
  children,
  featureFlags,
}: {
  children: ReactNode;
  featureFlags: FF;
}) {
  const [iteration, setIteration] = useState(0);
  const ff = featureFlags;

  useEffect(() => {
    // Intercept `set` so every flag mutation bumps `iteration`, which is part
    // of the context value and therefore forces consumers to re-render.
    // Preserved verbatim from upstream flagg; only the surrounding types changed.
    const originalSet = featureFlags.set;
    ff.set = (...args: Parameters<typeof originalSet>) => {
      const rVal = originalSet(...args);
      setIteration((val) => val + 1);
      return rVal;
    };
  }, []);

  return (
    <FlaggContext.Provider value={{ featureFlags: ff, iteration }}>
      {children}
    </FlaggContext.Provider>
  );
}
